import { render, staticRenderFns } from "./AfaPrescrizioneEserciziModalEditComponent.vue.vue?vue&type=template&id=82ed20ec&scoped=true"
import script from "./AfaPrescrizioneEserciziModalEditComponent.vue.vue?vue&type=script&lang=js"
export * from "./AfaPrescrizioneEserciziModalEditComponent.vue.vue?vue&type=script&lang=js"
import style0 from "./AfaPrescrizioneEserciziModalEditComponent.vue.vue?vue&type=style&index=0&id=82ed20ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ed20ec",
  null
  
)

export default component.exports